import React from 'react';

export default function FootIcon({
  size = '50px', // or any default size of your choice
  color = 'black',
}) {
  return (
    <svg
      style={{ width: size, height: { size }, marginRight: '2px' }}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 96 96"
      version="1.1"
      y="0px"
      x="0px"
    >

      <g id="banana" />

      <g id="Layer_12" />

      <g id="grape" />

      <g id="assasin" />

      <g id="gold" />

      <g id="mage_ass" />

      <g id="fighter" />

      <g id="SUPPORT" />

      <g id="marksman" />

      <g id="JUNGLE" />

      <g id="TANK" />

      <g className="st0" id="creditcard" />

      <g className="st0" id="CAKE" />

      <g className="st0" id="TOPI" />

      <g className="st0" id="SPATU" />

      <g className="st0" id="SETTING" />

      <g className="st0" id="CART" />

      <g className="st0" id="k3" />

      <g className="st0" id="computer" />

      <g className="st0" id="phone" />

      <g className="st0" id="location" />

      <g id="koper">

        <g id="Layer_29" />

        <g>

          <path d="M20.6,63l0.6,3.6l0.6-3.6H20.6z" />

          <path d="M26.2,62.8l0.6,3.4l0.6-3.4H26.2z" />

          <path d="M47.3,62.9l0.6,3.5l0.6-3.5L47.3,62.9z" />

          <path d="M59.8,63.2l0.6,3.6l0.6-3.6H59.8z" />

          <path d="M67.1,63l0.6,3.6l0.6-3.6H67.1z" />

          <path d="M15.8,37.5c-2,5.6-5.1,16.9-1.4,23.4c6.3,0.9,11.1,0.1,15.7-0.7c5.3-0.9,10.4-1.8,16.5,0.5c2,0.5,8.1,1,25.3,0    c6.3-0.4,11.3-4.5,11.3-7.8c0-2.9-3.9-5-10.4-5.6c0,0-0.1,0-0.1,0c-0.1,0-0.1,0-0.2,0c-0.1,0-0.3,0-0.4-0.1    C68.8,46.3,50,42,39.5,36.4c-2-1-3.5-2.1-4.7-3.1c-0.5-0.4-0.7-0.4-0.7-0.4c-0.6,0.2-1.2,3-1.5,4.6c-0.8,3.8-1.8,8.2-5,9    c-2.7,0.7-5-1.3-9.6-6.2" />

          <path className="st1" d="M37.8,40.2c-0.2,0-0.3,0-0.5-0.1c-0.5-0.3-0.7-0.9-0.4-1.4l1.9-3.5c0.3-0.5,0.9-0.7,1.4-0.4    c0.5,0.3,0.7,0.9,0.4,1.4l-1.9,3.5C38.5,40,38.1,40.2,37.8,40.2z" />

          <path className="st1" d="M43.4,42.2c-0.2,0-0.3,0-0.5-0.1c-0.5-0.3-0.7-0.9-0.4-1.4l1.7-3.1c0.3-0.5,0.9-0.7,1.4-0.4    c0.5,0.3,0.7,0.9,0.4,1.4l-1.7,3.1C44.1,42,43.8,42.2,43.4,42.2z" />

          <path className="st1" d="M49.1,43.6c-0.2,0-0.3,0-0.5-0.1c-0.5-0.3-0.7-0.9-0.4-1.4l1.4-2.6c0.3-0.5,0.9-0.7,1.4-0.4s0.7,0.9,0.4,1.4    L50,43.1C49.8,43.4,49.5,43.6,49.1,43.6z" />

          <path className="st1" d="M54.3,44.7c-0.2,0-0.3,0-0.4-0.1c-0.5-0.2-0.7-0.8-0.4-1.3l1.1-2.2c0.2-0.5,0.9-0.7,1.3-0.4    c0.5,0.2,0.7,0.8,0.4,1.3l-1.1,2.2C55,44.5,54.6,44.7,54.3,44.7z" />

          <path className="st1" d="M55.3,47.3c-2.8,0-6.6-0.8-11.2-2.3c-5.8-1.8-9.1-2.9-11-3.5c-3.1-1-3.3-1.1-3-2c0.3-1,1.3-0.7,1.6-0.6    c0.1,0,0.2,0.1,0.3,0.1c1.1,0.4,4.1,1.4,12.6,4.1c10.1,3.2,13.2,2,14.1,1.4c0.6-0.5,0.6-1,0.6-1.1c0-0.5,0.4-1,0.9-1.1    c0.5,0,1,0.3,1.1,0.9c0,0.2,0.1,1.6-1.3,2.8C59,46.9,57.4,47.3,55.3,47.3z" />

          <path className="st3" d="M12,50.8c-0.4,0-0.8-0.3-1-0.7c-0.1-0.5,0.2-1.1,0.7-1.2l7.4-2.1c0.5-0.1,1.1,0.2,1.2,0.7    c0.1,0.5-0.2,1.1-0.7,1.2l-7.4,2.1C12.1,50.8,12.1,50.8,12,50.8z" />

          <path className="st3" d="M12,54.8c-0.4,0-0.8-0.3-1-0.7c-0.1-0.5,0.2-1.1,0.7-1.2l7.4-2.1c0.5-0.1,1.1,0.2,1.2,0.7    c0.1,0.5-0.2,1.1-0.7,1.2l-7.4,2.1C12.2,54.8,12.1,54.8,12,54.8z" />

        </g>

      </g>

      <g className="st0" id="guide" />

      <g id="MAGICAL" />

      <g id="phisical" />

      <g id="mango" />

      <g id="orange" />
    </svg>
  );
}
